import log from 'salvo-lite/log'
import axios from 'axios'

class CustomWishlist {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._inner = this._elem.querySelector('[data-custom-wishlist-inner]')
        this._wishlistApi = window.esc_wishlist = window.esc_wishlist || []
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._elem.setAttribute('data-app', 'eastsideco_wishlist')
        const url = this._inner.getAttribute('data-custom-wishlist-inner') + '.json'
        axios.get(url).then((response) => {
            const info = JSON.stringify(response.data.product)
            this._inner.setAttribute(':product', info)
            this._wishlistApi.push(api => {
                api.emit('initialize', [this._elem])
            })
        })
    }
}

export default CustomWishlist



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CustomWishlist.js